import { app } from '../app';

app.config(config);

/** @ngInject */
function config($urlRouterProvider) {
    $urlRouterProvider.when('/logoutSAML/', '/logoutSAML');
}



// WEBPACK FOOTER //
// ./src/portal/states/url-rewrite.state.js